import { createHashHistory as history } from "history";

export default history();



// WEBPACK FOOTER //
// ./src/component/history.js